<template>
	<div class="my-races">
		<transition>
			<component
				:is="selectedComponent.value"
				:filter="filter"
				class="races-container"
				@snackbar-event="$emit('snackbar-event', $event)"
				@loading="$emit('loading', $event)"
				@change-component="changeComponent"
				:componentOptions="componentOptions"
				:selectedComponent="selectedComponent"
			></component>
		</transition>
	</div>
</template>

<script>
import RacesContainer from "../../components/user/RacesContainer";
import CircuitsContainer from "../../components/user/CircuitsContainer";

export default {
	components: {
		RacesContainer,
		CircuitsContainer,
	},
	data() {
		return {
			filter: {
				inscribed: true,
				notStarted: true,
			},
			componentOptions: [
				{ text: "Carreras", value: "RacesContainer" },
				{ text: "Circuitos", value: "CircuitsContainer" },
			],
			selectedComponent: { text: "Carreras", value: "RacesContainer" },
		};
	},
	methods: {
		changeComponent(e) {
			this.selectedComponent = e;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";
@import "../../scss/_variables.scss";
.my-races {
	padding: 0.5em;
	display: flex;
	justify-content: center;

	background-color: #f0f0f3;
	min-height: 100vh;

	@include desktop {
		flex-direction: row;
		padding: 2em;
	}

	.races-container {
		width: 100%;
		max-width: 1400px;
	}
}
</style>
